export default __webpack_public_path__ + "static/Logo-057692e4def5c35ea8f76ac5fae27200.svg";